import {
  createSlice,
} from '@reduxjs/toolkit';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';

export const ProfileModalSlice = createSlice({
  name: 'profileModal',
  initialState: { open: false, avatarImage: null },
  reducers: {
    setOpen(state, action) {
      return _set(_cloneDeep(state), 'open', action.payload);
    },
    setAvatarImage(state, action) {
      return _set(_cloneDeep(state), 'avatarImage', action.payload);
    },
  },
});

export const {
  setOpen,
  setAvatarImage,
} = ProfileModalSlice.actions;

export default ProfileModalSlice.reducer;
